import typeCheck from 'common/util/typeCheck';
import { SR_API_ACTION_ID_VERIFICATION_GET_BY_USER_SESSION } from 'api/actionTypes';

export default async function getByUserSession(
  { state, apiClient },
  { forceRefresh = false } = {},
) {
  const currentUserId = state.get(['currentUser', 'id']);
  typeCheck('currentUserId::PositiveNumber', currentUserId);
  const statePath = ['idVerifications', 'byUserId', currentUserId];
  if (state.get(statePath) && !forceRefresh) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_ID_VERIFICATION_GET_BY_USER_SESSION,
    queryId: String(currentUserId),
    state: state,
    onSuccess(idVerification) {
      state.set(statePath, idVerification);
    },
  });
}
